"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deduplicateArray = void 0;
function deduplicateArray(items, key) {
    const keyArr = Array.isArray(key) ? key : [key];
    const itemsMap = items.reduce((acc, item) => {
        const itemKey = keyArr.map(key => item[key]).join(',');
        return {
            ...acc,
            [itemKey]: item
        };
    }, {});
    return Object.keys(itemsMap).map(itemKey => itemsMap[itemKey]);
}
exports.deduplicateArray = deduplicateArray;
